import React, { useState } from "react";
import ListViewActions from "../../shared/ListViewActions";
import { GenericTable } from "@shared/components/GenericTable";
import { TableAction } from "@shared/types/table";
import { useSearchParams } from "react-router-dom";
import { useValidationContext } from "@features/mx/validations/context";
import { missingReadingHeaders } from "@features/mx/validations/types";
import { useMissingReadingsList, usePutEstimateReadings, useMissingReadingsExport } from "@features/mx/validations/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PAGE_SIZE } from "@shared/utils/constants";
import { logEvent } from "@shared/analytics/analytics";
import { useToast } from "@shared/hooks/use-toast";

function MissingReadingLanding() {
  const [searchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState("");
  const [selectedPremises, setSelectedPremises] = useState<string[]>([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const {toast} = useToast()
  const { meterRunId } = useValidationContext();
  const remoteUtilityId = useRemoteUtilityId();

  const { data: missingReadingsList } = useMissingReadingsList({
    remoteUtilityId,
    meterRunId,
    page: currentPage,
    limit: PAGE_SIZE,
    searchData: searchValue,
    premises: selectedPremises,
  });

  const { mutate: estimateReading } = usePutEstimateReadings(meterRunId);
  const { exportCSV } = useMissingReadingsExport(
    remoteUtilityId,
    meterRunId,
    searchValue,
    selectedPremises
  );

  const handleExport = async () => {
    await exportCSV();
    logEvent("MX Reading List Exported", {
      type: "Missing Readings",
      count: missingReadingsList?.count,
    });
  };

const pagination = {
  currentPage,
  totalPages: Math.ceil((missingReadingsList?.count || 0) / PAGE_SIZE),
  totalItems: missingReadingsList?.count || 0,
  itemsPerPage: PAGE_SIZE,
  startItem: (currentPage - 1) * PAGE_SIZE + 1,
  endItem: Math.min(currentPage * PAGE_SIZE, missingReadingsList?.count || 0),
};

const handleEstimateReadings = () => {
    if (!selectedRows)
    {
      toast({
        title: "Select the reading(s) to estimate first"
      })
    }
    else {
      estimateReading({
        jobCardIds: selectedRows
      }, {
      onSuccess: (res) => {
        console.log('debug res', res);
        toast({
          title: "Reading auto complete started.",
          description: "Readings validating in background. Please move to Pass tab to view the result"
        })
      }
      })
    }
  }

  return (
    <div className="space-y-4">
      <ListViewActions
        onExportClick={handleExport}
        onSearch={(val) => setSearchValue(val)}
        onRouteChange={(val) => setSelectedPremises(val)}
        onAutoComplete={handleEstimateReadings}
      />
      {missingReadingsList?.results && (
        <GenericTable
          data={missingReadingsList.results}
          columns={missingReadingHeaders}
          rowKey="id"
          selectable={true}
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          actionsType="icons"
          pagination={pagination}
          onPageChange={setCurrentPage}
          emptyMessage="No readings found"
        />
      )}
    </div>
  );
}

export default MissingReadingLanding;
